import React from "react";

const SpecificAssetsSymbol = ({ family, color }) => {
  const common = {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (family) {
    case "water_tower":
      return (
        <svg {...common}>
          <path d="M9 5h6" />
          <path d="M8 8h8v4H8z" />
          <path d="M10 12v6" />
          <path d="M14 12v6" />
          <path d="M8 18h8" />
        </svg>
      );

    case "culvert":
      return (
        <svg {...common}>
          <path d="M4 14c2-4 4-6 8-6s6 2 8 6" />
          <path d="M6 14h12" />
          <path d="M8 14v3" />
          <path d="M16 14v3" />
        </svg>
      );

    case "borehole":
      return (
        <svg {...common}>
          <path d="M12 4v16" />
          <circle cx="12" cy="7" r="2.5" />
          <path d="M9.5 20h5" />
        </svg>
      );

    case "solar_field":
      return (
        <svg {...common}>
          <path d="M5 10l6-2 1 5-6 2z" />
          <path d="M13 8l6-2 1 5-6 2z" />
          <path d="M9 15l1 3" />
          <path d="M16 13l1 3" />
          <path d="M7 20h12" />
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <rect x="5" y="5" width="14" height="14" rx="3" />
        </svg>
      );
  }
};

export default SpecificAssetsSymbol;